import {
  HomeIcon,
  UserCircleIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuthStore } from "hooks";
import micIcon from "images/microfono-para-cantar.png";

// eslint-disable-next-line
const FooterNav = ({}: any) => {
  const { status, startLogout } = useAuthStore();
  const location = useLocation();
  const authenticated = status === "authenticated";

  const handleLogOut = () => startLogout();

  // Los items laterales cambian según el estado de sesión.
  const leftItem: any = authenticated
    ? { name: "Mi cuenta", link: "/account", icon: UserCircleIcon }
    : { name: "Inicio", link: "/", icon: HomeIcon };

  const rightItem: any = authenticated
    ? { name: "Salir", link: "/login", icon: ArrowRightOnRectangleIcon, onClick: handleLogOut }
    : { name: "Acceder", link: "/login", icon: UserCircleIcon };

  const SideLink = ({ item }: { item: any }) => {
    const active = location.pathname === item.link;
    const Icon = item.icon;
    return (
      <Link
        to={item.link}
        onClick={item.onClick}
        className={`flex w-16 flex-col items-center justify-end gap-1 pb-1 transition-colors ${
          active
            ? "text-purple-600 dark:text-purple-300"
            : "text-neutral-500 hover:text-neutral-800 dark:text-neutral-300/90 dark:hover:text-white"
        }`}
      >
        <Icon className="h-6 w-6" />
        <span className="text-[11px] leading-none">{item.name}</span>
      </Link>
    );
  };

  const reservarActive = location.pathname === "/rooms";

  return (
    <div
      className="FooterNav fixed inset-x-0 bottom-0 z-30 border-t border-neutral-200 bg-white/95 backdrop-blur dark:border-neutral-700 dark:bg-neutral-900/95"
      style={{ paddingBottom: "max(0.375rem, env(safe-area-inset-bottom))" }}
    >
      <div className="relative mx-auto flex max-w-lg items-end justify-around px-4 pt-2">
        <SideLink item={leftItem} />

        {/* Reservar — botón central elevado y destacado */}
        <Link
          to="/rooms"
          aria-label="Reservar"
          className="flex flex-col items-center"
        >
          <span
            className={`-mt-8 grid h-16 w-16 place-items-center rounded-full bg-gradient-to-br from-violet-600 to-fuchsia-600 text-white shadow-lg shadow-violet-600/40 ring-4 ring-white transition-transform duration-150 active:scale-95 dark:ring-neutral-900 ${
              reservarActive ? "scale-105" : ""
            }`}
          >
            <img
              src={micIcon}
              alt=""
              className="h-11 w-11"
              style={{ filter: "brightness(0) invert(1)" }}
            />
          </span>
          <span className="mt-1 pb-1 text-[12px] font-bold text-violet-600 dark:text-violet-300">
            Reservar
          </span>
        </Link>

        <SideLink item={rightItem} />
      </div>
    </div>
  );
};

export default FooterNav;
